import {documentLoadEvent} from "../../../webpack/modules/events";
import {updateItemsNumber} from "../../../webpack/modules-optimized/cart";

documentLoadEvent(function() {
    updateItemsNumber();
});